<template>
  <el-table
    :data="tableData"
    height="100%"
    max-height="100%"
    border
    stripe
    v-el-table-infinite-scroll="load"
    @sort-change="sortChange"
    :show-summary="true"
    :summary-method="getSummaries"
    ref="table"
    style="width: 100%"
    @row-dblclick="jumpDetails"
  >
    <el-table-column type="index" align="center" fixed width="40">
      <template slot="header">
        <el-tooltip
          slot="reference"
          class="item"
          effect="dark"
          content="设置隐藏列(点击显示/隐藏)"
          placement="top"
        >
          <el-button
            icon="el-icon-s-tools"
            type="text"
            @click="getCustomColumns"
          ></el-button>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column prop="warehouseName" width="120" label="库房名称" fixed :index="1"> </el-table-column>
    <el-table-column prop="saleAmt" width="110" label="销售金额" sortable="custom" :index="2"> </el-table-column>
    <el-table-column prop="saleQty" width="116" label="销售大数量" sortable="custom" :index="3"> </el-table-column>
    <el-table-column prop="returnAmt" width="110" label="退货金额" sortable="custom" :index="4"> </el-table-column>
    <el-table-column prop="returnQty" width="116" label="退货大数量" sortable="custom" :index="5"> </el-table-column>
    <el-table-column prop="salBackAmt" width="110" label="还货金额" sortable="custom" :index="6"> </el-table-column>
    <el-table-column prop="saleBackQty" width="116" label="还货大数量" sortable="custom" :index="7"> </el-table-column>
    <el-table-column prop="totalAmt" width="110" label="合计金额" sortable="custom" v-if="customColumnList['totalAmt']" :index="8"> </el-table-column>
    <el-table-column prop="totalQty" width="116" label="合计大数量" sortable="custom" v-if="customColumnList['totalQty']" :index="9"> </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    tableData: Array,
    sum: {
      type: Object,
      default: {}
    },
    transmitQuery:Object
  },
  data() {
    return {
      customColumnsList: [
        {
          label: "合计金额",
          prop: "totalAmt",
        },
        {
          label: "合计大数量",
          prop: "totalQty",
        }
      ],
      customColumn: []
    };
  },
  computed: {
    customColumnList () {
      let tempItem = {}
      this.customColumn.forEach(i => {
        tempItem[i.prop] = (i.isShow == 'Y')
      })
      return tempItem
    }
  },
  created() {
    this.getCustomColumnsList();
  },
  methods: {
    load() {
      this.$emit("get-table-data");
    },
    async getCustomColumnsList() {
      const { data: res } = await this.$http.post(
        "Account/dataSearchVue/selectColumnByFuncCode.html",
        this.Qs.stringify({ funcCode: 219 })
      );
      if (res.code != "success")
        return this.$confirm(res.message, "提示", {
          confirmButtonText: "确定",
          showCancelButton: false,
          type: "error",
        });
      let result = JSON.parse(res.result);
      let tempArr = [];
      let arr = [];
      this.customColumnsList.some((item) => {
        if (item.power && !item.power.every((row) => this.power[row] == "Y"))
          return false;
        if (item.children) {
          item.children = this.customColumnsFilterOfPower(item.children);
        }
        tempArr.push(item);
      });
      tempArr.forEach((item) => {
        result.forEach(($item) => {
          if (item.prop == $item.prop) {
            if (item.children && item.children.length) {
              arr.push({
                id: $item.id,
                label: item.label,
                prop: item.prop,
                isShow: $item.isShow,
                children: this.mergeArr(item.children, $item.children, "prop"),
              });
            } else {
              arr.push({
                id: $item.id,
                label: item.label,
                prop: item.prop,
                isShow: $item.isShow,
              });
            }
          }
        });
      });
      this.customColumn = [ ...arr ]
    },
    mergeArr(arr1, arr2, unique) {
      let arr = [];
      arr1.forEach((m) => {
        arr2.forEach((n) => {
          if (m[unique] == n[unique]) {
            arr.push({
              id: n.id,
              label: m.label,
              prop: m.prop,
              isShow: n.isShow,
            });
          }
        });
      });
      return arr;
    },
    getCustomColumns() {
      this.$emit("columns", this.customColumn);
    },
    sortChange({ prop, order }) {
      this.$emit("sort", { prop, order })
    },
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      for (let key in this.sum) {
        columns.forEach((column, index) => {
          if (index == 1) {
            sums[index] = "合计";
            return;
          }
          if (column.property == key) {
            sums[index] = this.sum[key];
            return;
          }
        });
      }
      this.$nextTick(() => {
        this.$refs['table'].doLayout();
      });
      return sums;
    },
    jumpDetails(row) {
      this.$emit('onSubmit')
      // 根据算选的   ，筛选右侧选项框的 查询条件
      console.log(row)
      for(let i in row) {
        Object.keys(this.transmitQuery).map((key) => {
            if(row[i] && i === this.transmitQuery[key].submitName) {
              let arr = []
              if(this.transmitQuery[key].selected.length) {
                  arr = this.transmitQuery[key].selected.filter(item => { return item.value === row[i] }) 
              } else {
                  let str = i.replace('ID','Name')
                  let obj = { value: row[i], text: row[str] }
                  arr.push(obj)

                  if(i === 'itemID' || i === 'customerID') {
                      this.transmitQuery[key].list = arr
                  }
              }
              this.transmitQuery[key].selected = arr
            }
        })
      }
      console.log(this.transmitQuery)
      let width = window.top.document.browser.availiframeWidth.value
      let height = window.top.document.browser.availiframeHeight.value
      let timestemp = new Date().getTime()
      this.transmitQuery.timestemp = timestemp
      top.addPanel('销售明细表(新)', `/templates/vue-account/dist/index.htm#/commodityDetails?type=1&timestemp=${timestemp}`, width, height, true, this.transmitQuery)
    }
  }
};
</script>

<style>
</style>